import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ink-900 text-gold-500">
                <div className="animate-pulse font-display text-xl">Verifying session…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/portal" replace />;
    }
    return children;
}
